/* eslint-disable */
import { RINGS_TYPE } from '@ringcentral-integration/commons/modules/RingtoneConfiguration/const';
export default {
  [RINGS_TYPE.Phone_Ring1]: 'Suoneria telefono 1',
  [RINGS_TYPE.Phone_Ring2]: 'Suoneria telefono 2',
  [RINGS_TYPE.Acoustic_Dreams]: 'Acustica',
  [RINGS_TYPE.Air_Raid]: 'Raid aereo',
  [RINGS_TYPE.Allusive]: 'Allusiva',
  [RINGS_TYPE.Attention]: 'Attenzione',
  [RINGS_TYPE.Blub_Blub]: 'Blub Blub',
  [RINGS_TYPE.Buzzy]: 'Ronzio',
  [RINGS_TYPE.Channel_Open]: 'Canale aperto',
  [RINGS_TYPE.Contemplation]: 'Contemplazione',
  [RINGS_TYPE.Crystal_Ball]: 'Cristallo',
  [RINGS_TYPE.Disco]: 'Disco',
  [RINGS_TYPE.Door_Bell]: 'Campanello',
  [RINGS_TYPE.Fairy]: 'Magico',
  [RINGS_TYPE.Fast_Bells]: 'Campane veloci',
  [RINGS_TYPE.High_Gong]: 'Gong acuto',
  [RINGS_TYPE.Immersion]: 'Immersione',
  [RINGS_TYPE.Indeed]: 'Indeed',
  [RINGS_TYPE.Lazy_Day]: 'Relax',
  [RINGS_TYPE.Neural_Funk]: 'Neurale',
  [RINGS_TYPE.Nice]: 'Gentile',
  [RINGS_TYPE.Ring]: 'Squillo',
  [RINGS_TYPE.Ringing_Bells]: 'Campane che suonano',
  [RINGS_TYPE.Simple]: 'Semplice',
  [RINGS_TYPE.Soothing]: 'Rassicurante',
  [RINGS_TYPE.Sunshine]: 'Raggio di sole',
  [RINGS_TYPE.Off]: 'Off',
  add: 'Aggiungi',
  delete: 'Elimina',
  play: 'Riproduci',
  cancel: 'Annulla',
  confirmToDelete: 'Eliminare {name}?',
} as const;

// @key: @#@"[RINGS_TYPE.Phone_Ring1]"@#@ @source: @#@"Phone Ring 1"@#@
// @key: @#@"[RINGS_TYPE.Phone_Ring2]"@#@ @source: @#@"Phone Ring 2"@#@
// @key: @#@"[RINGS_TYPE.Acoustic_Dreams]"@#@ @source: @#@"Acoustic Dreams"@#@
// @key: @#@"[RINGS_TYPE.Air_Raid]"@#@ @source: @#@"Air Raid"@#@
// @key: @#@"[RINGS_TYPE.Allusive]"@#@ @source: @#@"Allusive"@#@
// @key: @#@"[RINGS_TYPE.Attention]"@#@ @source: @#@"Attention"@#@
// @key: @#@"[RINGS_TYPE.Blub_Blub]"@#@ @source: @#@"Blub Blub"@#@
// @key: @#@"[RINGS_TYPE.Buzzy]"@#@ @source: @#@"Buzzy"@#@
// @key: @#@"[RINGS_TYPE.Channel_Open]"@#@ @source: @#@"Channel Open"@#@
// @key: @#@"[RINGS_TYPE.Contemplation]"@#@ @source: @#@"Contemplation"@#@
// @key: @#@"[RINGS_TYPE.Crystal_Ball]"@#@ @source: @#@"Crystal Ball"@#@
// @key: @#@"[RINGS_TYPE.Disco]"@#@ @source: @#@"Disco"@#@
// @key: @#@"[RINGS_TYPE.Door_Bell]"@#@ @source: @#@"Door Bell"@#@
// @key: @#@"[RINGS_TYPE.Fairy]"@#@ @source: @#@"Fairy"@#@
// @key: @#@"[RINGS_TYPE.Fast_Bells]"@#@ @source: @#@"Fast Bells"@#@
// @key: @#@"[RINGS_TYPE.High_Gong]"@#@ @source: @#@"High Gong"@#@
// @key: @#@"[RINGS_TYPE.Immersion]"@#@ @source: @#@"Immersion"@#@
// @key: @#@"[RINGS_TYPE.Indeed]"@#@ @source: @#@"Indeed"@#@
// @key: @#@"[RINGS_TYPE.Lazy_Day]"@#@ @source: @#@"Lazy Day"@#@
// @key: @#@"[RINGS_TYPE.Neural_Funk]"@#@ @source: @#@"Neural Funk"@#@
// @key: @#@"[RINGS_TYPE.Nice]"@#@ @source: @#@"Nice"@#@
// @key: @#@"[RINGS_TYPE.Ring]"@#@ @source: @#@"Ring"@#@
// @key: @#@"[RINGS_TYPE.Ringing_Bells]"@#@ @source: @#@"Ringing Bells"@#@
// @key: @#@"[RINGS_TYPE.Simple]"@#@ @source: @#@"Simple"@#@
// @key: @#@"[RINGS_TYPE.Soothing]"@#@ @source: @#@"Soothing"@#@
// @key: @#@"[RINGS_TYPE.Sunshine]"@#@ @source: @#@"Sunshine"@#@
// @key: @#@"[RINGS_TYPE.Off]"@#@ @source: @#@"Off"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"delete"@#@ @source: @#@"Delete"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"confirmToDelete"@#@ @source: @#@"Delete {name}?"@#@
